<!--
 * @Author: Alfred huqitaoit@gmail.com
 * @Date: 2021-12-20 11:08:35
 * @LastEditors: Alfred
 * @LastEditTime: 2023-12-15 14:44:11
 * @Description: 
 * @FilePath: \src\views\order\OrderRefundAudit.vue
-->
<template>
  <div class="order-refund-audit">
    <OrderFilterAudit
      :type.sync="type"
      @updateFilter="updateFilter"
    />
    <OrderRefundAuditDetail
      :type.sync="type"
      :search.sync="search"
    />
  </div>
</template>
<script>
import OrderFilterAudit from '@/components/order/OrderFilterAudit.vue'
import OrderRefundAuditDetail from '@/components/order/OrderRefundAuditDetail.vue'
export default {
  name: 'OrderRefundAudit',
  components: {
    OrderFilterAudit,
    OrderRefundAuditDetail
  },
  data() {
    return {
      type: 'refundAudit',
      search: {
        p: 1,
        limit: 10,
        shop_id: '0',
        payment: '',
        status: '1',
        give_type: '0'
      }
    }
  },
  mounted() {},
  methods: {
    updateFilter(val) {
      this.search = val
    }
  }
}
</script>
<style lang="scss"></style>
